module.exports = __webpack_public_path__ + "static/media/icon-gallery-dark.1177a8cf.svg";